export function formatHoursDotMinutes(totalMinutes) {
  const minutes = Number(totalMinutes);
  if (!Number.isFinite(minutes) || minutes <= 0) {
    return "—";
  }

  let hours = Math.floor(minutes / 60);
  let remainder = Math.round(minutes % 60);
  if (remainder === 60) {
    hours += 1;
    remainder = 0;
  }
  return `${hours}.${String(remainder).padStart(2, "0")} h`;
}

export function sortTelemetryScheduleRows(rows, newestFirst) {
  const list = Array.isArray(rows) ? rows.slice() : [];
  list.sort((left, right) => {
    const a = String((left && left.date) || "");
    const b = String((right && right.date) || "");
    const byDate = newestFirst ? b.localeCompare(a) : a.localeCompare(b);
    if (byDate !== 0) return byDate;
    const leftName = String(
      (left && (left.operatorName || left.operator_name)) || ""
    );
    const rightName = String(
      (right && (right.operatorName || right.operator_name)) || ""
    );
    const byName = leftName.localeCompare(rightName, "pt-BR");
    if (byName !== 0) return byName;
    return Number(left && left.operatorId) - Number(right && right.operatorId);
  });
  return list;
}
